import { useEffect } from "react";
import { Flex, Button, Form, Upload } from "antd";

import StyledModal from "./style";

const ModalSettingsLogo = ({
  activeLogoUrl,
  loading,
  onCancel,
  onSuccess,
  open,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) form.resetFields();
  }, [open]);

  return (
    <StyledModal
      closeIcon={false}
      footer={
        <Flex justify="space-between">
          <Button onClick={onCancel} shape="round">
            Cancel
          </Button>
          <Button
            disabled={loading}
            form="formDashboardVideo"
            htmlType="submit"
            shape="round"
            type="primary"
          >
            Update
          </Button>
        </Flex>
      }
      onCancel={onCancel}
      open={open}
      title="Update Logo"
      width={647}
    >
      <Form
        form={form}
        id="formDashboardVideo"
        layout="vertical"
        onFinish={onSuccess}
      >
        <Form.Item
          name="file"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Upload.Dragger
            beforeUpload={() => false}
            maxCount={1}
            name="file"
            style={{ paddingLeft: 30 }}
          >
            <Flex
              align="center"
              justify="center"
              gap={15}
              style={{ height: 70 }}
            >
              <span className="ant-upload-drag-icon"></span>
              <span className="ant-upload-text" style={{ color: "#105DAE" }}>
                Drag here or <u>Browse</u>
              </span>
            </Flex>
          </Upload.Dragger>
        </Form.Item>
      </Form>

      {activeLogoUrl && (
        <>
          <p style={{ marginBottom: 8 }}>
            Current Logo (Supported formats: svg, jpg, png)
          </p>
          <img alt="Company Logo" src={activeLogoUrl} style={{ height: 42 }} />
        </>
      )}
    </StyledModal>
  );
};

export default ModalSettingsLogo;
